/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable prettier/prettier */
import React from 'react';

const DpoIcon = () => {
  return (
    <svg
      width="32px"
      height={'32px'}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Artboard</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12.6570988,4.21241996 C12.9816125,3.91258218 13.4877493,3.93258592 13.7875871,4.25709957 C14.0874249,4.58161322 14.0674211,5.08775006 13.7429075,5.38758784 L6.50459859,12.0754991 C6.18099099,12.3744997 5.67653602,12.3555602 5.37625944,12.0331362 L2.21456834,8.63824929 C1.91345103,8.31492256 1.93145532,7.80871065 2.25478204,7.50759334 C2.57810877,7.20647604 3.08432067,7.22448032 3.38543798,7.54780705 L6.00405741,10.3595672 L12.6570988,4.21241996 Z"
          id="dpo-checkmark-star-svg"
        ></path>
      </defs>
      <g
        id="Artboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icons/checkmark" transform="translate(8.000000, 8.000000)">
          <mask id="mask-2" fill="white">
            <use href="#dpo-checkmark-star-svg"></use>
          </mask>
          <use
            id="checkmark"
            fill="#00B2A9"
            fillRule="nonzero"
            href="#dpo-checkmark-star-svg"
          ></use>
          <g
            id="Color/greyDarker-424242"
            mask="url(#mask-2)"
            fill="#424242"
            fillRule="evenodd"
          >
            <rect id="color" x="0" y="0" width="16" height="15.9912521"></rect>
          </g>
        </g>
        <g id="GDPRStars-07" fill="#0249BA" fillRule="nonzero">
          <path
            d="M16,0.08 L16.71,1.52 L16.71,1.52 L18.3,1.75 L17.21,2.93 L17.48,4.51 C17.48,4.51 17.48,4.51 17.48,4.51 L16,3.82 L16,3.82 L14.58,4.57 C14.58,4.57 14.53,4.57 14.58,4.57 L14.8,3 L13.64,1.81 C13.64,1.81 13.64,1.81 13.64,1.81 L15.22,1.58 C15.22,1.58 15.22,1.58 15.22,1.58 L16,0.08 Z"
            id="Path"
          ></path>
          <path
            d="M8,2.25 L9.33,3.14 L9.33,3.14 L10.82,2.55 L10.39,4.09 L10.39,4.09 L11.39,5.32 C11.39,5.32 11.39,5.32 11.39,5.32 L9.79,5.38 L9.79,5.38 L9,6.86 C9,6.86 9,6.86 9,6.86 L8.44,5.36 L8.44,5.36 L6.84,4.94 C6.84,4.94 6.84,4.94 6.84,4.89 L8.1,3.89 L8.1,3.89 L8,2.27 L8,2.25 Z"
            id="Path"
          ></path>
          <path
            d="M2.2,8.11 L3.8,8.22 L3.8,8.22 L4.82,7 C4.82,7 4.82,7 4.82,7 L5.21,8.55 L5.21,8.55 L6.71,9.11 C6.71,9.11 6.71,9.11 6.71,9.16 L5.43,10 L5.43,10 L5.37,11.61 C5.37,11.61 5.37,11.61 5.32,11.61 L4.09,10.61 L4.09,10.61 L2.51,11 C2.51,11 2.51,11 2.51,11 L3.1,9.51 L3.1,9.51 L2.18,8.16 L2.2,8.11 Z"
            id="Path"
          ></path>
          <path
            d="M0.08,16.11 L1.52,15.4 L1.52,15.4 L1.75,13.81 L2.87,14.96 L3,14.96 L4.58,14.69 C4.58,14.69 4.58,14.69 4.58,14.69 L3.83,16.11 L3.83,16.11 L4.58,17.53 C4.58,17.53 4.58,17.53 4.58,17.53 L3,17.34 L3,17.34 L1.81,18.49 L1.58,16.9 C1.58,16.9 1.58,16.9 1.58,16.9 L0.08,16.16 L0.08,16.11 Z"
            id="Path"
          ></path>
          <path
            d="M2.25,24.1 L3.14,22.76 L3.14,22.76 L2.55,21.27 C2.55,21.27 2.55,21.22 2.55,21.27 L4.09,21.71 L4.09,21.71 L5.32,20.71 L5.38,22.31 C5.38,22.31 5.38,22.31 5.38,22.31 L6.74,23.17 C6.74,23.17 6.74,23.17 6.74,23.22 L5.24,23.77 L5.24,23.77 L4.85,25.32 L3.85,24.06 C3.85,24.06 3.85,24.06 3.85,24.06 L2.25,24.16 C2.25,24.16 2.23,24.12 2.25,24.1 Z"
            id="Path"
          ></path>
          <path
            d="M8.11,29.93 L8.22,28.33 L8.22,28.33 L7,27.31 L8.55,26.91 L9.11,25.41 C9.11,25.41 9.11,25.41 9.16,25.41 L10,26.7 L10,26.7 L11.61,26.77 C11.61,26.77 11.61,26.77 11.61,26.77 L10.61,28.01 L11,29.62 C11,29.62 11,29.67 11,29.62 L9.51,29.02 L9.51,29.02 L8.16,30 L8.11,29.93 Z"
            id="Path"
          ></path>
          <path
            d="M16.11,32.05 L15.4,30.61 L15.4,30.61 L13.81,30.38 C13.81,30.38 13.81,30.38 13.81,30.33 L14.96,29.21 C14.96,29.21 14.96,29.21 14.96,29.21 L14.69,27.63 C14.69,27.63 14.69,27.63 14.69,27.63 L16.11,28.37 L17.53,27.63 C17.53,27.63 17.53,27.63 17.53,27.63 L17.26,29.21 C17.26,29.21 17.26,29.21 17.26,29.21 L18.4,30.33 C18.4,30.33 18.4,30.33 18.4,30.38 L16.81,30.61 L16.81,30.61 L16.1,32.05 L16.11,32.05 Z"
            id="Path"
          ></path>
          <path
            d="M24.1,29.89 L22.76,29 C22.76,29 22.76,29 22.76,29 L21.27,29.6 C21.27,29.6 21.22,29.6 21.27,29.6 L21.65,28 C21.65,28 21.65,28 21.65,28 L20.65,26.76 C20.65,26.76 20.65,26.76 20.65,26.76 L22.25,26.69 C22.25,26.69 22.25,26.69 22.25,26.69 L23.11,25.34 L23.66,26.85 L23.66,26.85 L25.21,27.25 C25.21,27.25 25.21,27.25 25.21,27.3 L23.95,28.3 C23.95,28.3 23.95,28.3 23.95,28.3 L24.05,29.9 C24.05,29.9 24.12,29.9 24.1,29.89 Z"
            id="Path"
          ></path>
          <path
            d="M29.93,24 L28.33,23.9 L28.33,23.9 L27.33,25.16 C27.33,25.16 27.33,25.16 27.33,25.16 L26.93,23.6 C26.93,23.6 26.93,23.6 26.93,23.6 L25.43,23.05 C25.43,23.05 25.43,23.05 25.43,23 L26.79,22.14 C26.79,22.14 26.79,22.14 26.79,22.14 L26.86,20.54 C26.86,20.54 26.86,20.54 26.86,20.54 L28.1,21.54 C28.1,21.54 28.1,21.54 28.1,21.54 L29.64,21.1 C29.64,21.1 29.69,21.1 29.64,21.1 L29.04,22.59 C29.04,22.59 29.04,22.59 29.04,22.59 L30,24 C30,24 30,24 29.93,24 Z"
            id="Path"
          ></path>
          <path
            d="M32.05,16 L30.61,16.71 C30.61,16.71 30.61,16.71 30.61,16.71 L30.38,18.3 L29.2,17.21 L29.2,17.21 L27.62,17.48 C27.62,17.48 27.62,17.48 27.62,17.48 L28.31,16 C28.31,16 28.31,16 28.31,16 L27.57,14.58 C27.57,14.58 27.57,14.53 27.57,14.58 L29.15,14.85 L29.15,14.85 L30.27,13.7 C30.27,13.7 30.27,13.7 30.32,13.7 L30.55,15.28 L30.55,15.28 L31.99,15.99 L32.05,16 Z"
            id="Path"
          ></path>
          <path
            d="M29.89,8 L29,9.37 L29.6,10.86 L28,10.49 L28,10.49 L26.76,11.49 L26.69,9.89 L25.28,9 C25.28,9 25.28,9 25.28,9 L26.79,8.44 L26.79,8.44 L27.19,6.89 C27.19,6.89 27.19,6.89 27.24,6.89 L28.24,8.15 L28.24,8.15 L29.86,8 L29.89,8 Z"
            id="Path"
          ></path>
          <path
            d="M24,2.2 L23.9,3.8 L25.16,4.8 L23.6,5.19 L23.6,5.19 L23.05,6.69 C23.05,6.69 23.05,6.69 23,6.69 L22.14,5.33 L22.14,5.33 L20.54,5.27 L21.54,4.04 L21.1,2.5 C21.1,2.5 21.1,2.5 21.1,2.5 L22.59,3.09 L22.59,3.09 L24,2.18 C24,2.18 24,2.18 24,2.2 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default DpoIcon;
